// extracted by mini-css-extract-plugin
export default {"wrapper":"Menu_wrapper__NyAq8","menuItemWrapper":"Menu_menuItemWrapper__zUQ6e"};